const TIME_PARAM_REGEX = /#t=(\d+\.?\d*|\.\d+)/;

export const removeTimeFromUrl = (url: string) => {
  return url.replace(TIME_PARAM_REGEX, '');
};
